import Model, { belongsTo, type HasMany, hasMany } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type {
  ReviApiResponse,
  ReviExchangeRate,
  ReviRemainingElementsResponse,
} from 'lumen/models';

export default class ReviMultiPropertyApiResponse extends Model {
  [Type] = 'revi-multi-property-api-response' as const;

  @belongsTo('revi-remaining-elements-response', {
    async: false,
    inverse: null,
  })
  declare remainingElements: ReviRemainingElementsResponse;

  @belongsTo('revi-api-response', { async: false, inverse: null })
  declare reservations: ReviApiResponse;

  @hasMany('revi-exchange-rate', { async: false, inverse: null })
  declare exchangeRates: HasMany<ReviExchangeRate>;
}
